export const products = [
  {
    id: 1,
    name: "The Lazy-Motion Library",
    priceId: "price_1RP7SmFXBh2FfiM2D3wRPXaj",
    price: 99,
    category: "premium"
  },
  {
    id: 2,
    name: "Advanced 3d Product Animation Course",
    priceId: "price_1PmGfEFXBh2FfiM23zNpC9pp",
    price: 40,
    category: "course"
  },
  {
    id: 3,
    name: "Textify: Callouts & Titles",
    priceId: "price_1T9WVQFXBh2FfiM2xp3NaPmM",
    price: 39,
    category: "tools"
  },
  {
    id: 4,
    name: "H2O droplet Simulation",
    priceId: "price_1PfilwFXBh2FfiM2Ce9p1FqB",
    price: 20,
    category: "effects"
  },
  {
    id: 5,
    name: "Pack of 5 Handmade motions",
    priceId: "price_1QWM21FXBh2FfiM21X0aVwgO",
    price: 15,
    category: "animations"
  },
  {
    id: 6,
    name: "Animated Arrays",
    priceId: "price_1QWLveFXBh2FfiM2hXqvkHx3",
    price: 10,
    category: "animations"
  },
  {
    id: 7,
    name: "Cloth Printing",
    priceId: "price_1QWLoBFXBh2FfiM2Jw1gEtIV",
    price: 10,
    category: "effects"
  },
  {
    id: 8,
    name: "Ice Off",
    priceId: "price_1RMDOsFXBh2FfiM2umglwjbB",
    price: 9,
    category: "effects"
  },
  {
    id: 9,
    name: "Cloth On Path",
    priceId: "price_1RMD3cFXBh2FfiM2Kddmsols",
    price: 8,
    category: "effects"
  },
  {
    id: 10,
    name: "Easy Grid",
    priceId: "price_1QWQliFXBh2FfiM2LexToGlc",
    price: 8,
    category: "tools"
  },
  {
    id: 11,
    name: "Motion Path",
    priceId: "price_1QWLrBFXBh2FfiM2XdHzF469",
    price: 8,
    category: "animations"
  },
  {
    id: 12,
    name: "Knitting",
    priceId: "price_1RMCpbFXBh2FfiM2q0d5pbb2",
    price: 8,
    category: "effects"
  },
  {
    id: 13,
    name: "Unfold",
    priceId: "price_1RMDH3FXBh2FfiM2OSyGZ6UD",
    price: 7,
    category: "effects"
  },
  {
    id: 14,
    name: "The Sprayer",
    priceId: "price_1RMD7xFXBh2FfiM2vgiPHmdb",
    price: 7,
    category: "effects"
  },
  {
    id: 15,
    name: "Water-bender",
    priceId: "price_1Q8P40FXBh2FfiM2EdzLBP6k",
    price: 7,
    category: "effects"
  },
  {
    id: 16,
    name: "MeshGen",
    priceId: "price_1RMDDoFXBh2FfiM2QiIH4gcd",
    price: 6,
    category: "tools"
  },
  {
    id: 17,
    name: "Soft Balls",
    priceId: "price_1QWM0ZFXBh2FfiM2LUfq2M1v",
    price: 6,
    category: "effects"
  },
  {
    id: 18,
    name: "Shift Line A & B",
    priceId: "price_1RMDHnFXBh2FfiM2Wjp32JAV",
    price: 5,
    category: "effects"
  },
  {
    id: 19,
    name: "Projector",
    priceId: "price_1RMDFzFXBh2FfiM2Y9UfauFQ",
    price: 5,
    category: "effects"
  },
  {
    id: 20,
    name: "Slideshow A",
    priceId: "price_1RMD8rFXBh2FfiM27hhFvwjl",
    price: 5,
    category: "effects"
  },
  {
    id: 21,
    name: "Bubbles on Path",
    priceId: "price_1QWLzdFXBh2FfiM2WyBPFmZC",
    price: 5,
    category: "effects"
  },
  {
    id: 22,
    name: "Things on Path",
    priceId: "price_1Q8P5BFXBh2FfiM2bgbmL9Ul",
    price: 5,
    category: "effects"
  },
  {
    id: 23,
    name: "The Tornado",
    priceId: "price_1RMDfxFXBh2FfiM2A2TLeZI2",
    price: 5,
    category: "effects"
  },
  {
    id: 24,
    name: "360 Loop",
    priceId: "price_1Q8PJYFXBh2FfiM2ywcoxwVw",
    price: 4,
    category: "animations"
  },
  {
    id: 25,
    name: "Auto Animate",
    priceId: "price_1Q8PItFXBh2FfiM2L3EinmLP",
    price: 4,
    category: "animations"
  },
  {
    id: 26,
    name: "Swirls",
    priceId: "price_1RMD73FXBh2FfiM2FvTIh3si",
    price: 4,
    category: "effects"
  },
  {
    id: 27,
    name: "Good Shapekeys",
    priceId: "price_1QWLxdFXBh2FfiM2jJiY0sEe",
    price: 4,
    category: "tools"
  },
  {
    id: 28,
    name: "Roll on Path",
    priceId: "price_1QWM3pFXBh2FfiM27PT0ZhgT",
    price: 4,
    category: "effects"
  },
  {
    id: 29,
    name: "Motion Domain",
    priceId: "price_1RMCuMFXBh2FfiM2afaW3bXj",
    price: 4,
    category: "animations"
  },
  {
    id: 30,
    name: "Ripples",
    priceId: "price_1RMD05FXBh2FfiM2ZCNNGiHq",
    price: 4,
    category: "effects"
  },
  {
    id: 31,
    name: "Slideshow B",
    priceId: "price_1RMD9XFXBh2FfiM2gYkPOpTZ",
    price: 4,
    category: "effects"
  },
  {
    id: 32,
    name: "Sprikles",
    priceId: "price_1RMDf7FXBh2FfiM2ofCMBn4d",
    price: 4,
    category: "effects"
  },
  {
    id: 33,
    name: "Levitate",
    priceId: "price_1RMD1DFXBh2FfiM2uR1E2Avh",
    price: 3,
    category: "effects"
  },
  {
    id: 34,
    name: "Gear Platform",
    priceId: "price_1RMD2ZFXBh2FfiM2BgdWYm6Q",
    price: 3,
    category: "effects"
  },
  {
    id: 35,
    name: "Wheel",
    priceId: "price_1RMDPsFXBh2FfiM2ezrEdtWP",
    price: 3,
    category: "effects"
  },
  {
    id: 36,
    name: "Pop up Pro",
    priceId: "price_1RMDFDFXBh2FfiM27vhVQqLT",
    price: 3,
    category: "effects"
  }
];

export const disabledWhenLazyMotionSelected = [
  4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36
];

export const specialBundleProducts = [1, 2, 3];
export const specialBundleStripeLink = "https://buy.stripe.com/28og2K5041VP7pC14s?prefilled_promo_code=ALN1";

export const discountTiers = [
  { minAmount: 0, maxAmount: 49, percentage: 0 },
  { minAmount: 50, maxAmount: 79, percentage: 10 },
  { minAmount: 80, maxAmount: 119, percentage: 15 },
  { minAmount: 120, maxAmount: 159, percentage: 20 },
  { minAmount: 160, maxAmount: 199, percentage: 25 },
  { minAmount: 200, maxAmount: Infinity, percentage: 30 }
];